module.exports = __webpack_public_path__ + "img/tower.9e638794.png";